import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { default as EN } from './en.json';
import { default as NL } from './nl.json';
import { default as DA } from './da.json';
import { default as FR } from './fr.json';
import { default as SV } from './sv.json';
import { default as DE } from './de.json';
import { default as ES } from './es.json';

export const availableLang = ['en', 'nl', 'fr', 'da', 'sv', 'de', 'es'] as const;

const languageDetector = new LanguageDetector(null, {
  order: ['querystring', 'cookie', 'localStorage', 'sessionStorage', 'navigator', 'htmlTag'],
  caches: ['cookie'],
  lookupQuerystring: 'language',
  convertDetectedLanguage: (lng) => lng.split('-')[0],
});

i18n
  .use(initReactI18next)
  .use(languageDetector)
  .init({
    resources: {
      en: {
        translation: EN,
      },
      nl: {
        translation: NL,
      },
      fr: {
        translation: FR,
      },
      da: {
        translation: DA,
      },
      sv: {
        translation: SV,
      },
      de: {
        translation: DE,
      },
      es: {
        translation: ES,
      },
    },
    fallbackLng: 'en' satisfies (typeof availableLang)[number],
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
